module.exports = __webpack_public_path__ + "img/PlantIt board.caaafd99.png";